import React from "react";
import {
  Icon,
  Button,
  Typography,
  TextField,
  Grid,
  Checkbox,
  Link,
  Select,
  MenuItem,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { userService } from "./../services/UserService";
import "../../styles/components/choose-number-modal.scss";
import BarLoader from "react-spinners/BarLoader";
import { css } from "@emotion/core";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: #7bc807;
  margin-bottom: 10px;
`;

const states = [
  { name: "Alabama", value: "AL" },
  { name: "Alaska", value: "AK" },
  { name: "Arizona", value: "AZ" },
  { name: "Arkansas", value: "AR" },
  { name: "California", value: "CA" },
  { name: "Colorado", value: "CO" },
  { name: "Connecticut", value: "CT" },
  { name: "Delaware", value: "DE" },
  { name: "Florida", value: "FL" },
  { name: "Georgia", value: "GA" },
  { name: "Hawaii", value: "HI" },
  { name: "Idaho", value: "ID" },
  { name: "Illinois", value: "IL" },
  { name: "Indiana", value: "IN" },
  { name: "Iowa", value: "IA" },
  { name: "Kansas", value: "KS" },
  { name: "Kentucky", value: "KY" },
  { name: "Louisiana", value: "LA" },
  { name: "Maine", value: "ME" },
  { name: "Maryland", valueimi: "MD" },
  { name: "Massachusetts", value: "MA" },
  { name: "Michigan", value: "MI" },
  { name: "Minnesota", value: "MN" },
  { name: "Mississippi", value: "MS" },
  { name: "Missouri", value: "MO" },
  { name: "Montana", value: "MT" },
  { name: "Nebraska", value: "NE" },
  { name: "Nevada", value: "NV" },
  { name: "New Hampshire", value: "NH" },
  { name: "New Jersey", value: "NJ" },
  { name: "New Mexico", value: "NM" },
  { name: "New York", value: "NY" },
  { name: "North Carolina", value: "NC" },
  { name: "North Dakota", value: "ND" },
  { name: "Ohio", value: "OH" },
  { name: "Oklahoma", value: "OK" },
  { namerel: "Oregon", value: "OR" },
  { name: "Pennsylvania", value: "PA" },
  { name: "Rhode Island", value: "RI" },
  { name: "South Carolina", value: "SC" },
  { name: "South Dakota", value: "SD" },
  { name: "Tennessee", value: "TN" },
  { name: "Texas", value: "TX" },
  { name: "Utah", value: "UT" },
  { name: "Vermont", value: "VT" },
  { name: "Virginia", value: "VA" },
  { name: "Washington", value: "WA" },
  { name: "West Virginia", value: "WV" },
  { name: "Wisconsin", value: "WI" },
  { name: "Wyoming", value: "WY" },
];

class BrandSetup extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    var user = JSON.parse(localStorage.getItem("user"));
    this.state = {
      open: props?.openAuto ? props.openAuto : false,
      church: user.success.user.churches[0].company
        ? user.success.user.churches[0].company
        : user.success.user.churches[0].name,
      ein: user.success.user.churches[0].ein,
      address: user.success.user.churches[0].address,
      city: user.success.user.churches[0].city,
      state: user.success.user.churches[0].state,
      zip: user.success.user.churches[0].zip,
      email: user.success.user.churches[0].email
        ? user.success.user.churches[0].email
        : user.success.user.email,
      phone: user.success.user.churches[0].phone
        ? user.success.user.churches[0].phone
        : user.success.user.mobile_phone,
      website: user.success.user.churches[0].website,
      error: {},
      loading: false,
      step2: user.success.user.churches[0].company,
      preview: false,
      success: false,
      threeMonthAdvance: false,
      file: null,
    };

    this.handleContinue = this.handleContinue.bind(this);
    this.checkForm = this.checkForm.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentDidMount() {
    var user = JSON.parse(localStorage.getItem("user"));

    if (
      user.success.phone_number &&
      user.success.phone_number.failed_reasons_object &&
      !user.success.phone_number.campaign_id
    ) {
      this.setState({ preview: true });
      user.success.phone_number.failed_reasons_object.forEach((item) => {
        if (item.fields[0] === "ein") {
          this.setState({ error: { ein: item.description } });
          this.setState({ preview: false });
        } else {
          this.setState({ errorText: item.description });
          this.setState({ preview: false });
        }
      });
    }
  }

  handleBack = () => {
    this.setState({ preview: false, step2: false });
  };

  handleChange = (prop) => (event) => {
    var value = event.target.value;
    var name = prop;
    if (prop === "threeMonthAdvance") {
      value = event.target.checked;
    }
    this.setState((currentState) => ({
      [name]:
        name === "ein" && !isNaN(value) && value.length === 2
          ? value + "-"
          : value,
      error: {
        ...currentState.error,
        [name]: "",
      },
    }));
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleFileChange(event) {
    const file =
      event.target.files && event.target.files[0]
        ? event.target.files[0]
        : null;
    this.setState((currentState) => ({
      file,
      error: {
        ...currentState.error,
        file: "",
      },
    }));
  }

  handleClose = (event, reason) => {
    console.log(reason);
    if (reason && reason === "backdropClick") return;
    this.setState({ open: false, error: {}, loading: false });
  };

  getSaveValidationErrors = () => {
    const { church, ein, address, city, zip, email, phone, file } = this.state;
    const requiredFields = {
      church,
      ein,
      address,
      city,
      zip,
      email,
      phone,
      file,
    };

    return Object.keys(requiredFields).reduce((errors, field) => {
      const value = requiredFields[field];
      const isEmpty =
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "");

      if (isEmpty) {
        const label = field === "ein" ? "EIN" : field;
        errors[field] = `The ${label} field is required.`;
      }

      return errors;
    }, {});
  };

  checkForm = () => {
    const { church, ein, address, city, state, zip, email, phone, website } =
      this.state;
    if (!church) {
      this.setState({ error: { church: "church is required" } });
      return false;
    }
    if (!ein) {
      this.setState({ error: { ein: "EIN is required" } });
      return false;
    }
    if (!ein.match(/^\d{2}-\d{7}$/)) {
      this.setState({ error: { ein: "EIN is not valid" } });
      return false;
    }
    if (!address) {
      this.setState({ error: { address: "address is required" } });
      return false;
    }
    if (!city) {
      this.setState({ error: { city: "city is required" } });
      return false;
    }
    if (!state) {
      this.setState({ error: { state: "state is required" } });
      return false;
    }
    if (!zip) {
      this.setState({ error: { zip: "zip is required" } });
      return false;
    }
    if (!email) {
      this.setState({ error: { email: "email is required" } });
      return false;
    }
    if (!phone) {
      this.setState({ error: { phone: "phone is required" } });
      return false;
    }
    if (!website) {
      this.setState({ error: { website: "website is required" } });
      return false;
    }

    return true;
  };

  handleContinue = (e) => {
    console.log(e);
    e.preventDefault();
    const validationErrors = this.getSaveValidationErrors();

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ error: validationErrors, loading: false });
      return;
    }

    // stop here if form is invalid
    if (!this.checkForm()) {
      return;
    }

    this.setState({ preview: true, step2: true, error: {} });
  };

  handleSave(e) {
    e.preventDefault();
    const validationErrors = this.getSaveValidationErrors();

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ error: validationErrors, loading: false });
      return;
    }

    const { church, ein, address, city, state, zip, email, phone, website } =
      this.state;
    const submit = false;
    const { file } = this.state;

    // stop here if form is invalid
    /*if (!this.checkForm()) {
      return;
    }*/

    this.setState({ loading: true });

    userService
      .saveBrand(
        church,
        ein,
        address,
        city,
        state,
        zip,
        email,
        phone,
        website,
        submit,
        file
      )
      .then(
        (data) => {
          if (data.status === "error" && data.field === "phone") {
            this.setState({ error: { phone: data.message }, loading: false });
          } else {
            this.setState({
              loading: false,
              open: false,
              error: {},
              step2: true,
            });
          }
        },
        (error) => {
          const fieldNames = [
            "church",
            "ein",
            "address",
            "city",
            "state",
            "zip",
            "email",
            "phone",
            "website",
            "file",
          ];
          let response = error;

          if (typeof response === "string") {
            try {
              response = JSON.parse(response);
            } catch (e) {
              response = { errorText: response };
            }
          }

          const validationErrors = fieldNames.reduce((errors, field) => {
            if (response && response[field]) {
              errors[field] = Array.isArray(response[field])
                ? response[field][0]
                : response[field];
            }
            return errors;
          }, {});

          if (
            response &&
            response.status === "error" &&
            response.field &&
            response.message
          ) {
            validationErrors[response.field] = response.message;
          }

          if (
            Object.keys(validationErrors).length === 0 &&
            response &&
            (response.errorText || response.message)
          ) {
            validationErrors.errorText = response.errorText || response.message;
          }

          this.setState({
            error: validationErrors,
            loading: false,
            preview: false,
          });
        }
      );
  }

  handleSubmit(e) {
    e.preventDefault();
    const { threeMonthAdvance } = this.state;
    if (threeMonthAdvance) {
      const {
        church,
        ein,
        address,
        city,
        state,
        zip,
        email,
        phone,
        website,
        file,
      } = this.state;
      const submit = true;
      this.setState({ loading: true });

      userService
        .saveBrand(
          church,
          ein,
          address,
          city,
          state,
          zip,
          email,
          phone,
          website,
          submit,
          file
        )
        .then(
          (data) => {
            this.setState({ loading: false, success: true });
            setTimeout(() => {
              this.setState({ open: false });
              window.location.reload(false);
            }, 2000);
          },
          (error) => {
            error.then((data) => {
              let res = JSON.parse(data);
              if (res.status === "error") {
                this.setState({
                  error: { errorText: res.message },
                  preview: false,
                });
              }
            });
            this.setState({ loading: false });
            return;
          }
        );
    }
  }

  render() {
    const {
      church,
      ein,
      address,
      city,
      state,
      zip,
      email,
      phone,
      website,
      file,
      error,
      open,
      threeMonthAdvance,
      preview,
      success,
      step2,
      loading,
    } = this.state;
    return (
      <div>
        {!open && (
          <Button
            color={step2 ? "yellow" : "primary"}
            variant="contained"
            onClick={this.handleClickOpen}
            classes={{
              root: "btn",
              label: "label",
              containedPrimary: step2
                ? "contained-primary nextbtn yellow-btn"
                : "contained-primary nextbtn",
            }}
            className={step2 ? "yellow-btn" : ""}
          >
            {step2 ? "Continue" : "Setup"}
          </Button>
        )}
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="add-new-number-one-title"
          aria-describedby="add-new-number-one-description"
          classes={{
            root: "add-new-number-modal",
            paper: "paper",
          }}
          BackdropProps={{
            classes: {
              root: "backdrop",
            },
          }}
        >
          <DialogContent>
            <div className="content">
              <div className="brand-wrapper">
                <Typography
                  className="main-title"
                  component={"p"}
                  style={{ marginLeft: 0, width: "100%", textAlign: "center" }}
                >
                  <Icon className="close-icon" onClick={this.handleClose}>
                    close
                  </Icon>
                  <div class={step2 ? "step-1" : "step-1 active"}>
                    1. Carrier Registration
                  </div>
                  <div class={step2 ? "step-2 active" : "step-2"}>
                    2. Purchase
                  </div>
                  <hr />
                </Typography>
                <Typography
                  className="main-title"
                  component={"p"}
                  style={{ marginLeft: 0, width: "100%", textAlign: "center" }}
                >
                  Make sure your church name, email, phone and address matches
                  what IRS has on file for your EIN.
                </Typography>
                <form name="form">
                  {loading && (
                    <BarLoader
                      css={override}
                      sizeUnit={"px"}
                      size={70}
                      color={"#7BC807"}
                      loading
                    />
                  )}
                  {error.hasOwnProperty("errorText") &&
                    error.errorText !== "" && (
                      <div
                        className={"alert alert-danger"}
                        dangerouslySetInnerHTML={{ __html: error.errorText }}
                      />
                    )}
                  {!preview && (
                    <Grid
                      container
                      spacing={2}
                      className="container brand"
                      id="brand-form"
                    >
                      <Grid item md={6} xs={12}>
                        <TextField
                          id="church"
                          label="Church"
                          value={church}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("church")}
                          error={typeof error.church === "string"}
                          helperText={error.church ? error.church : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item md={6} xs={12}>
                        <TextField
                          id="ein"
                          label="EIN"
                          value={ein}
                          fullWidth
                          variant="filled"
                          placeholder="XX-XXXXXXX"
                          onChange={this.handleChange("ein")}
                          error={typeof error.ein === "string"}
                          helperText={error.ein ? error.ein : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <TextField
                          id="address"
                          label="Address"
                          value={address}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("address")}
                          error={typeof error.address === "string"}
                          helperText={error.address ? error.address : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <TextField
                          id="city"
                          label="City"
                          value={city}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("city")}
                          error={typeof error.city === "string"}
                          helperText={error.city ? error.city : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Select
                          labelId="demo-controlled-open-select-label"
                          id="state"
                          value={state}
                          onChange={this.handleChange("state")}
                          error={typeof error.state === "string"}
                          helperText={error.state ? error.state : ""}
                          className={`state-select`}
                        >
                          {states.map((item, index) => (
                            <MenuItem key={index} value={item.value}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <TextField
                          id="zip"
                          label="Zip"
                          value={zip}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("zip")}
                          error={typeof error.zip === "string"}
                          helperText={error.zip ? error.zip : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <TextField
                          id="email"
                          label="Email"
                          value={email}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("email")}
                          error={typeof error.email === "string"}
                          helperText={error.email ? error.email : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <TextField
                          id="phone"
                          label="Phone"
                          value={phone}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("phone")}
                          error={typeof error.phone === "string"}
                          helperText={error.phone ? error.phone : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <TextField
                          id="website"
                          label="Website"
                          value={website}
                          fullWidth
                          variant="filled"
                          onChange={this.handleChange("website")}
                          error={typeof error.website === "string"}
                          helperText={error.website ? error.website : ""}
                          classes={{
                            root: "text-field",
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "label",
                            },
                          }}
                          InputProps={{
                            classes: {
                              root: "input-wrapper",
                              input: "input",
                            },
                          }}
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <div className="brand-file-upload">
                          <input
                            id="brand-supporting-file"
                            type="file"
                            onChange={this.handleFileChange}
                            className="brand-file-upload__input"
                          />
                          <div className="brand-file-upload__content">
                            <div className="brand-file-upload__copy">
                              <Typography
                                className="brand-file-upload__title"
                                component={"p"}
                              >
                                Supporting document
                              </Typography>
                              <Typography
                                className="brand-file-upload__subtitle"
                                component={"p"}
                              >
                                Upload your file for carrier registration.
                              </Typography>
                            </div>
                            <label
                              htmlFor="brand-supporting-file"
                              className="brand-file-upload__button"
                            >
                              {file ? "Change file" : "Choose file"}
                            </label>
                          </div>
                          <Typography
                            className="brand-file-upload__name"
                            component={"p"}
                          >
                            {file ? file.name : "No file selected"}
                          </Typography>
                          {error.file ? (
                            <Typography
                              className="brand-file-upload__error"
                              component={"p"}
                            >
                              {error.file}
                            </Typography>
                          ) : null}
                        </div>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Button
                          color="default"
                          variant="contained"
                          type="submit"
                          onClick={this.handleSave}
                          disabled={loading}
                          classes={{
                            root: "btn",
                            label: "label",
                            containedPrimary: "contained-primary nextbtn",
                          }}
                        >
                          Save for Later
                        </Button>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          onClick={this.handleContinue}
                          disabled={loading}
                          classes={{
                            root: "btn",
                            label: "label",
                            containedPrimary:
                              "contained-primary nextbtn float-right",
                          }}
                        >
                          Continue
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                  {preview && !success && (
                    <Grid
                      container
                      spacing={2}
                      className="container brand"
                      id="brand-preview"
                    >
                      <Grid item xs={12}>
                        <Typography className="main-title" component={"p"}>
                          <Button
                            color="primary"
                            variant="contained"
                            component={Link}
                            to="#"
                            type="submit"
                            onClick={this.handleBack}
                            classes={{
                              root: "btn",
                              label: "label",
                              containedPrimary: "contained-primary",
                            }}
                          >
                            Edit
                          </Button>
                        </Typography>
                        <Typography className="main-title" component={"p"}>
                          Church: {church}
                        </Typography>
                        <Typography className="main-title" component={"p"}>
                          EIN: {ein}
                        </Typography>
                        <Typography className="main-title" component={"p"}>
                          Address: {address} {city} {state} {zip}
                        </Typography>
                        <Typography className="main-title" component={"p"}>
                          Email: {email}
                        </Typography>
                        <Typography className="main-title" component={"p"}>
                          Phone: {phone}
                        </Typography>
                        <Typography className="main-title" component={"p"}>
                          Website: {website}
                        </Typography>
                        {file && (
                          <Typography className="main-title" component={"p"}>
                            File: {file.name}
                          </Typography>
                        )}
                        <Typography className="name">
                          Your one-time $15 10DLC brand and campaign
                          registration fee was collected when you subscribed. No
                          additional registration fee will be charged here.
                        </Typography>
                        <Typography className="name">
                          <Checkbox
                            id="threeMonthAdvance"
                            className="checkbox"
                            checked={threeMonthAdvance}
                            onChange={this.handleChange("threeMonthAdvance")}
                            value={true}
                            inputProps={{
                              "aria-label": "primary checkbox",
                            }}
                          />
                          I understand that all campaigns require a 3-month
                          minimum commitment. If my campaign is approved, I
                          agree to a one time upfront charge of $15.00 ($5/month
                          for 3 months). After the initial 3 month period, a
                          $5.00/month fee will be added to my plan total on a
                          month to month basis until canceled.
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className="main-title" component={"p"}>
                          Campaign 3-month ($5/m) minimum commitment
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          className="main-title float-right"
                          component={"p"}
                        >
                          $15
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography className="main-title" component={"p"}>
                          Total
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          className="main-title float-right"
                          component={"p"}
                        >
                          $15
                        </Typography>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Button
                          color="default"
                          variant="contained"
                          type="submit"
                          onClick={this.handleSave}
                          disabled={loading}
                          classes={{
                            root: "btn",
                            label: "label",
                            containedPrimary: "contained-primary nextbtn",
                          }}
                        >
                          Save for Later
                        </Button>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Button
                          color={threeMonthAdvance ? "primary" : "default"}
                          variant="contained"
                          type="submit"
                          onClick={this.handleSubmit}
                          className="btn contained-primary nextbtn float-right"
                        >
                          Purchase & Submit
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </form>
                {preview && success && (
                  <Grid item xs={12}>
                    <Typography className="main-title" component={"p"}>
                      Registration Successful
                    </Typography>
                  </Grid>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default BrandSetup;
